import MapWithPads from './mapWithPads';

export default MapWithPads;
